<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    max-width="1000"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        small
        @click="dialog = true"
        :disabled="!isReallyActive"
      >
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>

      <v-form class="top" ref="form" v-model="valid">
        <v-toolbar>
          <v-toolbar-title>
            {{ $t("seePromotion") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div :class="$vuetify.breakpoint.smAndDown ? '' : 'px-6'">
          <v-card-text>
            <div>
              <v-subheader class="overline pt-4">
                {{ $t("promotionImageWithoutAsterisk") }}
              </v-subheader>
              <div class="pa-4 px-6 mb-4" max-width="70%">
                <v-img :src="promotionImage" class="mx-auto" max-width="70%" />
                <v-skeleton-loader type="image" v-if="promotionImage === ''" />
              </div>
            </div>

            <v-subheader class="overline">
              {{ $t("typeAndCodeOfPromotion") }}
            </v-subheader>
            <div class="pa-4 px-6 mb-4">
              <v-select
                v-model="promotion.type"
                class="mb-6"
                :items="items"
                item-text="text"
                item-value="status"
                :label="$t('typeOfPromotionSelect')"
                hide-details="auto"
                dense
                outlined
                return-object
                disabled
              ></v-select>
              <div class="d-flex align-center">
                <v-text-field
                  v-if="isPromotionTypeToken"
                  v-model="quantityTokens"
                  class=""
                  :label="$t('quantityOfTokens')"
                  hide-details
                  dense
                  type="number"
                  outlined
                  disabled
                ></v-text-field>
                <v-text-field
                  v-if="
                    isPromotionTypeDeposit || isPromotionTypeRegisterOrAffiliate
                  "
                  v-model="promotion.code_promo"
                  class=""
                  :label="$t('promotionCode')"
                  hide-details
                  dense
                  outlined
                  disabled
                ></v-text-field>
                <div v-if="isPromotionTypeToken" class="tooltip">
                  <v-icon class="tooltipIcon">
                    mdi-information-outline
                  </v-icon>
                  <span class="tooltipText body-2">
                    {{ $t("tokenTip") }}
                  </span>
                </div>
                <div
                  v-if="
                    isPromotionTypeDeposit || isPromotionTypeRegisterOrAffiliate
                  "
                  class="tooltip"
                >
                  <v-icon class="tooltipIcon">
                    mdi-information-outline
                  </v-icon>
                  <span class="tooltipText body-2">
                    {{ $t("promotionCodeTip") }}
                  </span>
                </div>
              </div>
              <div
                v-if="isPromotionTypeToken"
                :style="$vuetify.breakpoint.smAndDown ? '' : 'width: 50%'"
                :class="
                  $vuetify.breakpoint.smAndDown
                    ? 'row d-flex flex-column no-gutters mt-2 grey--text'
                    : 'row no-gutters mt-2 grey--text'
                "
              >
                <div class="sm6">
                  {{ $t("redeemedTokens") }}: {{ promotion.ransomed }}
                  {{ $t("of") }}
                  {{ promotion.ransomed + promotion.not_ransomed }}
                </div>
              </div>
            </div>
            <!-- codigo -->

            <div class="pa-0 mb-4" v-if="promotion.type.status === 'afiliado'">
              <v-subheader class="overline pt-4">
                {{ $t("findAnAffiliate") }}
              </v-subheader>
              <!-- Autocomplete Agente -->
              <div class="pa-4 px-6 ">
                <v-autocomplete
                  v-model="promotion.affiliate"
                  :items="[promotion.affiliate]"
                  item-text="ui"
                  item-value="id"
                  :label="$t('autoCompleteAffiliatePlaceHolder')"
                  :no-data-text="$t('autoCompleteNoData')"
                  :hint="$t('searchAffiliateSpan')"
                  persistent-hint
                  prepend-icon="mdi-magnify"
                  dense
                  outlined
                  clearable
                  hide-details="auto"
                  return-object
                  disabled
                >
                </v-autocomplete>
              </div>
            </div>

            <div class="pa-0">
              <v-subheader class="overline pt-4">
                {{ `${$t("title")} ${$t("and")} ${$t("description")}` }}
              </v-subheader>
              <div class="pa-4 px-6">
                <v-text-field
                  v-model="promotion.title"
                  :label="$t('promotionTitle')"
                  hide-details="auto"
                  dense
                  outlined
                  :counter="40"
                  maxlength="40"
                  disabled
                ></v-text-field>
                <v-text-field
                  class="pt-2"
                  v-model="promotion.description"
                  :label="$t('promotionDescription')"
                  hide-details="auto"
                  dense
                  outlined
                  :counter="50"
                  maxlength="50"
                  disabled
                ></v-text-field>
              </div>
            </div>

            <!-- row Date Start -->
            <v-subheader class="overline">
              {{ $t("validity") }}
            </v-subheader>
            <div class="pa-4 px-6">
              <v-row>
                <v-col>
                  <v-menu
                    v-model="menuStart"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    min-width="200"
                    class=""
                    offset-y
                    disabled
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="promotion.date_inicial"
                        outlined
                        :label="$t('dateStart')"
                        prepend-icon="mdi-calendar"
                        readonly
                        hint="DD/MM/YYYY"
                        hide-details="auto"
                        class=""
                        v-on="on"
                        dense
                        disabled
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="promotion.date_inicial"
                      @input="menuStart = false"
                      no-title
                      scrollable
                      disabled
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <!-- row Date Final -->
              <v-row>
                <v-col>
                  <v-menu
                    v-model="menuFinal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="200"
                    class=""
                    disabled
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="promotion.date_final"
                        outlined
                        :label="$t('dateFinal')"
                        prepend-icon="mdi-calendar"
                        readonly
                        hint="DD/MM/YYYY"
                        hide-details="auto"
                        class=""
                        v-on="on"
                        dense
                        disabled
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dateFinal"
                      @input="menuFinal = false"
                      no-title
                      scrollable
                      disabled
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </div>
            <div>
              <v-subheader class="overline">
                {{ $t("rewardRules") }}
              </v-subheader>
              <div class="pa-4 px-6">
                <v-row>
                  <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'">
                    <!-- Bonus - Dependendo do tipo pode ser aplicado como percentual ou valor absoluto. -->
                    <div class="d-flex align-center">
                      <v-text-field
                        class="custom-prepend-inner-icon"
                        v-model="promotion.bonus"
                        :label="
                          isPromotionTypeDeposit
                            ? $t('percentageOfBonus')
                            : $t('promotionLabelBonus')
                        "
                        prepend-icon="mdi-seal-variant"
                        :prefix="
                          isPromotionTypeDeposit ? '%' : $t('labelCurrency')
                        "
                        hide-details="auto"
                        dense
                        outlined
                        type="number"
                        disabled
                      ></v-text-field>
                      <div class="tooltip">
                        <v-icon class="tooltipIcon"
                          >mdi-information-outline</v-icon
                        >
                        <span class="tooltipText body-2">
                          <span v-if="isPromotionTypeDeposit">{{
                            $t("promotionTypeDepositTip")
                          }}</span>
                          <span v-else>{{
                            $t("prmotionTypeRegisterOrAfiliateTip")
                          }}</span>
                        </span>
                      </div>
                    </div>
                  </v-col>
                  <v-col
                    v-if="
                      !isPromotionTypeRegisterOrAffiliate &&
                        !isPromotionTypeToken
                    "
                    :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'"
                  >
                    <!-- Bonus Máximo (no caso de ser percentual) -->
                    <div class="d-flex align-center">
                      <v-text-field
                        v-model="promotion.bonus_max"
                        :label="$t('LabelMaximumBonusAmount')"
                        :prefix="$t('labelCurrency')"
                        hide-details="auto"
                        prepend-icon="mdi-license"
                        dense
                        outlined
                        type="number"
                        disabled
                      >
                      </v-text-field>
                      <div class="tooltip">
                        <v-icon class="tooltipIcon">
                          mdi-information-outline
                        </v-icon>
                        <span class="tooltipText body-2">
                          {{ $t("bonusMaxValueTip") }}
                        </span>
                      </div>
                    </div>
                  </v-col>
                  <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'">
                    <div class="d-flex align-center">
                      <div style="width: 100%">
                        <!-- Transfer máximo  - caso exista, limita a transferencia para o saldo real -->
                        <div class="d-flex align-center">
                          <v-text-field
                            v-model="promotion.transfer_max"
                            :label="$t('maxTransference')"
                            :prefix="$t('labelCurrency')"
                            prepend-icon="mdi-bank-transfer"
                            hide-details="auto"
                            dense
                            outlined
                            disabled
                          ></v-text-field>
                          <div class="tooltip">
                            <v-icon class="tooltipIcon">
                              mdi-information-outline
                            </v-icon>
                            <span class="tooltipText body-2">
                              {{ $t("maxTransferTooltip") }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
            <!-- TEXT INPUTS -->
            <div>
              <div v-if="isPromotionTypeDeposit">
                <v-subheader class="overline pt-4">
                  {{ $t("adhesionRules") }}
                </v-subheader>
                <div class="pa-4 px-6">
                  <v-row>
                    <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'">
                      <div class="d-flex align-center">
                        <v-text-field
                          v-model="promotion.deposito_min"
                          :label="$t('minimumDeposit')"
                          prepend-icon="mdi-cash-fast"
                          hide-details="auto"
                          dense
                          outlined
                          type="number"
                          disabled
                        ></v-text-field>
                        <div class="tooltip">
                          <v-icon class="tooltipIcon">
                            mdi-information-outline
                          </v-icon>
                          <span class="tooltipText body-2">
                            {{ $t("depositMinValueTip") }}
                          </span>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <v-subheader class="overline pt-4">
                {{ $t("rolloverRules") }}
              </v-subheader>
              <div class="pa-4 px-6">
                <v-row class="mb-3">
                  <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'">
                    <div class="d-flex align-center">
                      <div style="width: 100%">
                        <!-- Rollover - fator que mult. o SALDO BONUS, resultando no valor a ser cumprido em apostas até que o saldo seja liberado -->
                        <div class="d-flex align-center">
                          <v-text-field
                            v-model="promotion.rollover_x"
                            :label="$t('rolloverMultiplier')"
                            hide-details="auto"
                            prepend-icon="mdi-dice-multiple"
                            prefix="x"
                            dense
                            outlined
                            type="number"
                            disabled
                          ></v-text-field>
                          <div class="tooltip">
                            <v-icon class="tooltipIcon">
                              mdi-information-outline
                            </v-icon>
                            <span class="tooltipText body-2">
                              {{ $t("multiRolloverTooltip") }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                  <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'">
                    <div class="d-flex align-center">
                      <v-text-field
                        v-model="promotion.days_expiration"
                        :label="$t('daysToExpire')"
                        prepend-icon="mdi-calendar-clock"
                        hide-details="auto"
                        dense
                        outlined
                        type="number"
                        disabled
                      ></v-text-field>
                      <div class="tooltip">
                        <v-icon class="tooltipIcon">
                          mdi-information-outline
                        </v-icon>
                        <span class="tooltipText body-2">
                          {{ $t("daysToRollover") }}
                        </span>
                      </div>
                    </div>
                  </v-col>
                  <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'">
                    <!-- Stake mínimo - mínimo valor por aposta para que seja considerado no cumprimento da promo -->
                    <div class="d-flex align-center">
                      <v-text-field
                        v-model="promotion.stake_min"
                        :label="$t('minBet')"
                        prepend-icon="mdi-cash-lock"
                        hide-details="auto"
                        dense
                        outlined
                        type="number"
                        disabled
                      ></v-text-field>
                      <div class="tooltip">
                        <v-icon class="tooltipIcon">
                          mdi-information-outline
                        </v-icon>
                        <span class="tooltipText body-2">
                          {{ $t("stakeMinValueTip1") }}
                          {{ $t("labelCurrency") }}
                          {{ $t("stakeMinValueTip2") }}
                        </span>
                      </div>
                    </div>
                  </v-col>
                  <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'">
                    <!-- Multiplicador máximo -->
                    <div class="d-flex align-center">
                      <v-text-field
                        v-model="promotion.multi_min"
                        :label="$t('minimumMultiplier')"
                        hide-details="auto"
                        prepend-icon="mdi-menu-up"
                        dense
                        outlined
                        type="number"
                        disabled
                      >
                      </v-text-field>
                      <div class="tooltip">
                        <v-icon class="tooltipIcon">
                          mdi-information-outline
                        </v-icon>
                        <span class="tooltipText body-2">
                          {{ $t("multMinValueTip") }}
                        </span>
                      </div>
                    </div>
                  </v-col>
                  <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'">
                    <!-- Multiplicador mínimo -->
                    <div class="d-flex align-center">
                      <v-text-field
                        v-model="promotion.multi_max"
                        :label="$t('maximumMutiplier')"
                        hide-details="auto"
                        prepend-icon="mdi-menu-down"
                        dense
                        outlined
                        type="number"
                        disabled
                      ></v-text-field>
                      <div class="tooltip">
                        <v-icon class="tooltipIcon">
                          mdi-information-outline
                        </v-icon>
                        <span class="tooltipText body-2">
                          {{ $t("multMaxValueTip") }}
                        </span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-card-text>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import AWS from "aws-sdk";
const bucketName = "sga-assets";
const bucketRegion = "sa-east-1";
const creds = new AWS.Credentials({
  accessKeyId: "accessKeyId",
  secretAccessKey: "secretAccessKey",
});

AWS.config.update({
  region: bucketRegion,
  credentials: creds,
});

const s3 = new AWS.S3({
  apiVersion: "2006-03-01",
  params: { Bucket: bucketName },
});

const s3BaseUrl = "https://s3.sa-east-1.amazonaws.com";

export default {
  props: [
    "promotionId",
    "affiliateName",
    "affiliatePromotion",
    "isReallyActive",
  ],
  data: () => ({
    promotionImage: "",

    promotion: {
      type: {},
    },

    dialog: false,
    valid: false,
    lazy: false,
    loading: false,
    promotionCode: "",
    quantityTokens: "",
    typePromotion: {},
    selectAffiliate: null,
    menuStart: "",
    dateStart: "",
    timeStart: "",
    menuFinal: "",
    dateFinal: "",
    timeFinal: "",
    daysToExpire: "",
    deposito_min_value: "",
    percentage_value: "",
    bonus_value: "",
    bonus_max_value: "",
    multi_min_value: "",
    multi_max_value: "",
    stake_min_value: "",
    rollover_x_value: "",
    transfer_max_value: "99999",
    isLoading: false,
    affiliates: [],
    search: null,
    term: "",
    items: [],
    hideDetailsStart: true,
    errorTimeStart: "",
    hideDetailsFinal: true,
    errorTimeFinal: "",
    image: null,
    imageLoaded: false,
    promotion_title: "",
    promotion_description: "",
    sigla: "",
  }),

  created() {
    this.items = [
      { text: this.$t("affiliate"), status: "afiliado" },
      { text: this.$t("register"), status: "cadastro" },
      { text: this.$t("deposit"), status: "deposito" },
      { text: this.$t("firstDeposit"), status: "1ºdeposito" },
      { text: this.$t("token"), status: "token" },
    ];
  },

  computed: {
    isPromotionTypeToken() {
      return this.promotion.type.status == "token";
    },

    isPromotionTypeDeposit() {
      return (
        this.promotion.type.status == "deposito" ||
        this.promotion.type.status == "1ºdeposito"
      );
    },
    isPromotionTypeRegisterOrAffiliate() {
      return (
        this.promotion.type.status == "cadastro" ||
        this.promotion.type.status == "afiliado"
      );
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.loading = true;

        this.$axios
          .post(
            "/administrator/promotions/getPromotion",
            this.$formdata({
              id: this.promotionId,
              has_affiliate: this.affiliatePromotion ? "1" : "0",
            })
          )
          .then((res) => {
            this.promotion = res.data.dados;

            if (
              this.promotion.type_promo === "afiliado" ||
              this.promotion.type_promo === "cadastro"
            ) {
              this.promotion.bonus = parseFloat(this.promotion.bonus).toFixed(
                2
              );
            }

            if (this.promotion.type_promo === "token") {
              this.quantityTokens = this.promotion.total_tokens;
            }

            this.promotion.date_inicial =
              new Date(
                this.promotion.date_inicial.replace(" ", "T")
              ).toLocaleDateString() +
              " " +
              new Date(
                this.promotion.date_inicial.replace(" ", "T")
              ).toLocaleTimeString();

            this.promotion.date_final =
              new Date(
                this.promotion.date_final.replace(" ", "T")
              ).toLocaleDateString() +
              " " +
              new Date(
                this.promotion.date_final.replace(" ", "T")
              ).toLocaleTimeString();

            this.promotion.type = this.items.find(
              ({ status }) => status === this.promotion.type_promo
            );

            if (this.promotion.type.status === "afiliado") {
              this.promotion.affiliate = {
                id: 1,
                ui: `${this.affiliateName} (${this.promotion.login_affiliate} ${this.promotion.id_affiliate})`,
              };
            }

            this.setPromotionImage(this.promotion.code_promo);
          })
          .finally(() => {
            this.loading = false;
          });

        const container = document.querySelector(".v-dialog--persistent");

        if (container) {
          this.$vuetify.goTo(".top", { container });
        }
      }
    },

    search(val) {
      // Caso o usuário selecionar um usuário da lista
      // não permitir realizar o get novamente.
      // O regex abaixo identifica os caracteres "(" e ")"
      // Contido na string e encerra dando return.
      if (/\(|\)/.test(val)) return;
      // aqui
      if (!val || val.length <= 0) {
        this.search_agent_items = [];
        this.sigla = "";
        this.term = "";
        return;
      }
      if (this.search_agent_isLoading) return;
      // Request

      if (val.length != 3 || val == this.sigla) {
        return;
      }

      this.sigla = val;

      if (val.length >= 3 && val != this.term) {
        this.term = val;
        this.getAffiliateList();
      }
      // aqui acaba
      // if (val == null || val.length <= 0) return;

      // if (this.isLoading) return;

      // // Request
      // if (val.length >= 3 && val != this.term) {
      //   this.term = val;
      //   this.getAffiliateList();
      // }
    },

    rollover_x_value(val) {
      this.rollover_x_value = val ? parseInt(this.rollover_x_value) : "";
    },
    daysToExpire(val) {
      this.daysToExpire = val ? parseInt(this.daysToExpire) : "";
    },
  },
  methods: {
    setPromotionImage(code) {
      const { db_name } = JSON.parse(localStorage.getItem("user_data"));

      const promise = s3
        .listObjects({
          Prefix: `domains/${db_name}/promotions/`,
        })
        .promise();

      const _this = this;

      promise.then((data) => {
        data.Contents.forEach((image) => {
          const encodedImageKey = encodeURIComponent(image.Key);
          const imageUrl = `${s3BaseUrl}/${bucketName}/${encodedImageKey}`;

          const splittedByDot = imageUrl.split(".")[
            imageUrl.split(".").length - 2
          ];

          const imageName = splittedByDot.split("%2F")[
            splittedByDot.split("%2F").length - 1
          ];

          if (imageName === code) {
            _this.promotionImage = imageUrl;
          }
        });
      });
    },
  },
};
</script>

<style>
input[type="file"] {
  display: none;
}
.cursorPointer {
  cursor: pointer;
}
.tooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;
  margin-left: 8px;
}
.tooltip .tooltipText {
  visibility: hidden;
  width: 320px;
  margin: auto;
  max-width: 280px;
  background-color: rgb(87, 87, 87);
  color: #fff;
  text-align: left;
  border-radius: 6px;
  padding: 12px 16px;
  bottom: 36px;
  right: -10%;
  hyphens: auto;
  word-break: normal;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltipText {
  visibility: visible;
}
</style>
